import { render, staticRenderFns } from "./ScheduleGridItem.vue?vue&type=template&id=0530c453"
import script from "./ScheduleGridItem.vue?vue&type=script&lang=js"
export * from "./ScheduleGridItem.vue?vue&type=script&lang=js"
import style0 from "./ScheduleGridItem.vue?vue&type=style&index=0&id=0530c453&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports